module.exports = __webpack_public_path__ + "img/communicator-go.41307a8b.png";